import { useNavigate } from 'react-router-dom'

import { Box, Link, SxProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useMappedTranslation } from 'hooks'

import useCookieAgreementCountry from './use-cookie-agreement-country'

export default function CookieAgreementLink() {
  const theme = useTheme()
  const navigate = useNavigate()
  const t = useMappedTranslation()
  const cookieAgreementCountry = useCookieAgreementCountry()
  const isShowCookieAgreementLink = cookieAgreementCountry === 'EUROPE' || cookieAgreementCountry === 'LATIN_AMERICA'
  const isDarkMode = theme.palette.mode === 'dark'

  const footerTextStyle: SxProps = {
    color: isDarkMode ? 'text.primary' : { xs: 'text.secondary', md: 'text.primary' },
    fontSize: '12px',
    lineHeight: '24px',
    alignItems: 'center',
    display: 'flex',
    fontWeight: { xs: '300', md: '500' }
  }

  const footerLinkDivStyle: SxProps = {
    cursor: 'pointer',
    height: '14px'
  }

  const handlePolicyCookie = () => {
    navigate('/policies/cookie')
  }

  return (
    <>
      {isShowCookieAgreementLink && (
        <Box sx={footerLinkDivStyle}>
          <Link
            component='button'
            type='button'
            underline='none'
            onClick={handlePolicyCookie}
            sx={{ ...footerTextStyle, cursor: 'pointer' }}
            data-testid='BoxDE61B152'
          >
            {t('footer.cookiePolicy')}
          </Link>
        </Box>
      )}
    </>
  )
}
